import FragmentSummary from "./fragment-summary";
import PatPointsAwarded from "./pat-points-awarded";

export default class PatPointsNotAwarded extends PatPointsAwarded {
    constructor() {
        super();
    }

    summarize(summaryContext, stringifier) {
        const message = "with no points awarded.";

        return new FragmentSummary(message);
    }
}
